export enum TemplateFilterSizeCategoryEnum {
  All = 'all',
  Square = 'square',
  Story = 'story',
  Portrait = 'portrait',
  Landscape = 'landscape',
  Unknown = 'unknown',
}
